import { EventEmitter, ElementRef } from '@angular/core';
import { CommonService } from '../../common.service';
var CasePracticeSceneChangeComponent = (function () {
    function CasePracticeSceneChangeComponent(commonService, el) {
        this.commonService = commonService;
        this.el = el;
        this.onFinish = new EventEmitter();
        this.clickAble = false; //按钮点击判断
    }
    CasePracticeSceneChangeComponent.prototype.ngOnInit = function () {
        this.setIsWrapClickedVal('.timeCount');
    };
    CasePracticeSceneChangeComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'transparent'
        });
    };
    CasePracticeSceneChangeComponent.prototype.goNext = function () {
        if (!this.clickAble) {
            return false;
        }
        else {
            this.onFinish.emit('sceneChange');
            this.clickAble = false;
        }
    };
    //根据动画播放结束设置点击判断
    CasePracticeSceneChangeComponent.prototype.setIsWrapClickedVal = function (dom) {
        var _this = this;
        var animateEndingElement = this.el.nativeElement.querySelector(dom);
        animateEndingElement.addEventListener('animationend', function () {
            // if(!this.clickAble){
            //   this.clickAble = true;
            // }
            setTimeout(function () {
                _this.onFinish.emit('sceneChange');
            }, 300);
        });
    };
    return CasePracticeSceneChangeComponent;
}());
export { CasePracticeSceneChangeComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-animation/case-practice-scene-change/case-practice-scene-change.component.ts.pre-build-optimizer.js